import { useQuery } from "@tanstack/react-query";
import { callGetEditorsList } from "../../../api/dataSources";
import useUserContext from "../../Authorization/useUserContext";

export default function useStudyEditorsStore() {
  const user = useUserContext();

  const query = useQuery({
    queryKey: ["study:editors_list"],
    queryFn: () => callGetEditorsList(user),
  });

  const getInitials = (name: string) => {
    const nameParts = name.split(" ");
    return nameParts
      .map((part) => part[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();
  };

  return {
    query,
    getInitials,
  };
}
